import styled from 'styled-components';

interface ContainerProps {
  menuWidth: number;
}
interface HeaderContainerProps {
  havePictureLogo: boolean;
}

interface ContentProps {
  isMobile: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: grid;
  flex: 1;
  min-height: 100%;
  position: relative;

  @media (min-width: 768px) {
    grid-template-columns: ${(props) => `${props.menuWidth}px`} auto;
    grid-template-rows: auto;
    grid-template-areas: 'dash-menu content';
  }

  scrollbar-color: #8f8d8d transparent;
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${(props) => props.theme.colors.background};

  .react-grid-layout {
    margin-bottom: 5px;
  }

  .layoutJSON {
    background: ${(props) => props.theme.colors.terciaryContent};
    border: 1px solid black;
    margin-top: 10px;
    padding: 10px;
  }

  .columns {
    -moz-columns: 120px;
    -webkit-columns: 120px;
    columns: 120px;
  }

  .react-grid-item {
    box-sizing: border-box;
  }

  .react-grid-item:not(.react-grid-placeholder) {
    background: ${(props) => props.theme.colors.terciaryContent};
  }

  .react-grid-item.resizing {
    opacity: 0.9;
  }

  .react-grid-item.static {
    background: ${(props) => props.theme.colors.terciaryContent};
  }

  .react-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 24px;
  }

  .react-grid-item .minMax {
    font-size: 12px;
  }

  .react-grid-item .add {
    cursor: pointer;
  }

  .react-grid-dragHandleExample {
    cursor: move;
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
  }

  li b {
    font-size: 19px;
    line-height: 14px;
  }

  .react-grid-layout {
    position: relative;
    transition: height 200ms ease;
  }

  .react-grid-item {
    transition: all 200ms ease;
    transition-property: left, top;
  }

  .react-grid-item.cssTransforms {
    transition-property: transform;
  }

  .react-grid-item.resizing {
    z-index: 1;
    will-change: width, height;
  }

  .react-grid-item.react-draggable-dragging {
    transition: none;
    z-index: 3;
    will-change: transform;
  }

  .react-grid-item.react-grid-placeholder {
    background: ${(props) => props.theme.colors.secondary};
    opacity: 0.2;
    transition-duration: 100ms;
    z-index: 2;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }

  .react-grid-item > .react-resizable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
    right: 0;
    background-position: bottom right;
    padding: 0 3px 3px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: se-resize;
  }

  .dash {
    display: flex;
    flex: 1;
  }
`;

export const HeaderContainer = styled.div<HeaderContainerProps>`
  grid-area: header;
  display: flex;
  border-radius: 5px;
  flex-direction: column;
  margin: 0px 0px 0px 10px;
  background-color: ${(props) => props.theme.colors.background};
  padding: ${(props) =>
    props.havePictureLogo ? '4px 20px 10px 10px' : '0 20px'};

  @media (min-width: 768px) {
    padding: ${(props) =>
    props.havePictureLogo ? '4px 20px 10px 10px' : '2px 20px'};
  }
`;

export const FooterContainer = styled.div`
  z-index: 0;
  height: 70px;
  border-top: 1px solid ${(props) => props.theme.colors.border};
  position: fixed;
  width: 100%;
  bottom: 0;

  @media (min-width: 768px) {
    min-height: 70px;
  }
`;

export const EmptyData = styled.div`
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: overlay;
`;
